import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const pendingRequestAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<PendingRequest>>('/api/info/pending_requests', { params }).then(({ data }) => data),
  approve: (pending_request_id: number, data: { approve: boolean }) =>
    http.post<unknown>(`/api/approve/pending_requests/${pending_request_id}`, { data }),
};

export const pendingRequestQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetPendingRequestList', params] as const,
      queryFn: () => pendingRequestAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
};
